import { useCallback, useEffect } from 'react';
import storeActions from '../actions';
import storeSelectors from '../selectors';
import { useAppDispatch } from 'store/hooks';
import { IApiGetListStoresParam } from 'modules/store/interfaces/api';

const useGetListStores = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const storesList = storeSelectors.getDataStores();
  const params = storeSelectors.getStoreListParams();

  const mutate = useCallback(
    (params: IApiGetListStoresParam) => {
      dispatch(storeActions.setListStoresParams(params));
    },
    [dispatch]
  );

  useEffect(() => {
    if (isLazy) return;
    mutate(params);
  }, []);

  return {
    storesList,
    params,
    mutate,
  };
};

export default useGetListStores;
